import React from "react";
import { Control, Controller, useController, UseFormGetValues, UseFormSetValue } from "react-hook-form";
import {useTranslation} from 'react-i18next';
import SelectBox from "@/components/Form/SelectBox/SelectBox";
import { ClaimSetupDescription } from "./type";


type ControlSelectType = {
    required?: boolean;
    isTextArea?: boolean;
    control: Control<ClaimSetupDescription>;
    name: string;
    showLabel: boolean;
    label: string;
    options: {
        label: string,
        value: string,
    }[];
    setValue: UseFormSetValue<ClaimSetupDescription>;
    getValues: UseFormGetValues<ClaimSetupDescription>;
    defaultValue?: string ;
}

export default function ControlSelect ({name, control, required=false, options, showLabel, label, setValue, getValues, defaultValue}: ControlSelectType) {
    const {
        field,
      } = useController({
        // @ts-ignore
        name,
        control,
        rules: { required: required },
      });
    const {t} = useTranslation();
    const translatedOptions = options.map(option => { 
        return {
            label: option.label,
            value: option.value,
        };
    })
    return (
        <> 
            {
                showLabel && <div className="formFieldLabel">
                    <label  htmlFor="input" aria-label={label}>{t(label)}{ required ? <span className="requiredSymbol">*</span> : ''}</label>
                </div>
            }
           <Controller
                name={field.name}
                control={control}
                defaultValue={defaultValue}
                rules={{ required }}
                render={({ field: { onChange, value }}) => {
                          return (
                          <>                        
                            <SelectBox  
                            options={translatedOptions} 
                            // @ts-ignore
                            value={value || defaultValue || ''} 
                            onChange={onChange} />
                          </>
                          );
                    }}
            />
        </>
        
    );
}
